import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CrmEventService extends Service {
	constructor(injector: Injector) {
		super("CrmEvent", injector);
	}

	getPast() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetPast`);
	}

	getUpcoming() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetUpcoming`);
	}
}
